/** Max patient rows fetched per Heidi-profile search; the dropdown scrolls beyond this. */
export const PATIENT_SEARCH_RESULT_LIMIT = 5;

export { EHR_PATIENT_SEARCH_MIN_QUERY_LENGTH } from '@/features/integrations-ehr/ehr-patient-search/constants';
